import React, { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogActions, Button, Alert,
  TextField, MenuItem, CircularProgress,
} from "@mui/material";
import axios from "../../../config/axiosConfig";
import { Encabezado, Seccion, Rejilla, fieldSx, contenidoSx, pieSx, botonPrincipalSx } from "./dialogoUi";

const DEPARTAMENTOS = ["La Paz", "Oruro", "Cochabamba", "Santa Cruz", "Beni", "Pando", "Tarija", "Potosi", "Chuquisaca"];
const TIPOS = [{ value: 1, label: "Contrato" }, { value: 2, label: "Eventual" }];
const hoy = () => new Date().toISOString().slice(0, 10);

// "Modificar Contrato" no edita la fila actual — crea una nueva Vigente (con la
// misma fecha_ini de siempre) y cierra la anterior. Ver permisosModel/plan para el
// detalle del porqué (mismo comportamiento que el legacy).
const camposIniciales = (contrato) => ({
  ciudad: contrato?.ciudad || "La Paz",
  cargo: contrato?.cargo || "",
  sueldo_basico: String(contrato?.sueldo_basico ?? ""),
  sueldo: String(contrato?.sueldo ?? "0"),
  tipo: contrato?.tipo || 1,
  fecha_fin: hoy(),
  observacion: "",
});

const ModificarContratoDialog = ({ open, onClose, empleadoId, contrato, onGuardado }) => {
  const [form, setForm] = useState(() => camposIniciales(contrato));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setForm(camposIniciales(contrato));
      setError("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleChange = (campo) => (e) => setForm((prev) => ({ ...prev, [campo]: e.target.value }));

  const puedeGuardar = form.ciudad && form.cargo && form.fecha_fin && !saving;

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.post(`/api/administracion-personal/empleado/${empleadoId}/modificar-contrato`, {
        id_contrato_anterior: contrato.id,
        ciudad: form.ciudad,
        cargo: form.cargo,
        sueldo_basico: Number(form.sueldo_basico) || 0,
        sueldo: Number(form.sueldo) || 0,
        tipo: Number(form.tipo),
        fecha_fin: form.fecha_fin,
        observacion: form.observacion.trim(),
      });
      onGuardado();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al modificar el contrato.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth scroll="paper">
      <Encabezado titulo="Modificar contrato" subtitulo="Cierra el contrato actual y registra uno nuevo" />
      <DialogContent sx={contenidoSx}>
        {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}
        <Alert severity="info" sx={{ py: 0 }}>
          Esto cierra el contrato actual y registra uno nuevo con los datos que completes aquí (la fecha de inicio original se conserva).
        </Alert>

        <Seccion titulo="Nuevo contrato">
          <Rejilla cols={2}>
            <TextField select size="small" label="Ciudad" value={form.ciudad} onChange={handleChange("ciudad")} sx={fieldSx}>
              {DEPARTAMENTOS.map((d) => <MenuItem key={d} value={d}>{d}</MenuItem>)}
            </TextField>
            <TextField select size="small" label="Tipo" value={form.tipo} onChange={handleChange("tipo")} sx={fieldSx}>
              {TIPOS.map((t) => <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>)}
            </TextField>
            <TextField size="small" label="Cargo" required value={form.cargo} onChange={handleChange("cargo")} sx={{ ...fieldSx, gridColumn: { sm: "span 2" } }} />
            <TextField size="small" type="number" label="Sueldo básico" value={form.sueldo_basico} onChange={handleChange("sueldo_basico")} sx={fieldSx} />
            <TextField size="small" type="number" label="Bono" value={form.sueldo} onChange={handleChange("sueldo")} sx={fieldSx} />
          </Rejilla>
        </Seccion>

        <Seccion titulo="Cambio" nota="cuándo se hace y por qué">
          <Rejilla cols={1}>
            <TextField size="small" type="date" label="Fecha de modificación" required InputLabelProps={{ shrink: true }} value={form.fecha_fin} onChange={handleChange("fecha_fin")} sx={fieldSx} />
            <TextField size="small" label="Observación" multiline minRows={2} value={form.observacion} onChange={handleChange("observacion")} sx={fieldSx} />
          </Rejilla>
        </Seccion>
      </DialogContent>
      <DialogActions sx={pieSx}>
        <Button onClick={onClose} disabled={saving} sx={{ textTransform: "none" }}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar} sx={botonPrincipalSx}>
          {saving ? <CircularProgress size={20} color="inherit" /> : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModificarContratoDialog;
